<div>
  <kl-share-update-form
    (postCreated)="onPostCreated($event);">
  </kl-share-update-form>
</div>
